import React from 'react';
import { 
  HelpCircle, 
  Utensils, 
  Activity, 
  Clock, 
  Scale, 
  Heart, 
  BarChart
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Utensils,
      title: 'Сбалансированное питание',
      description: 'Следуйте принципам здорового питания: больше овощей, фруктов, цельнозерновых продуктов и белка. Ограничьте потребление сахара и насыщенных жиров.'
    },
    {
      icon: Activity,
      title: 'Регулярная активность',
      description: 'По рекомендациям Минздрава РФ, взрослым необходимо минимум 150 минут умеренной или 75 минут интенсивной активности в неделю.'
    },
    {
      icon: Clock,
      title: 'Режим питания',
      description: 'Питайтесь в одно и то же время, не пропускайте приемы пищи и избегайте ночных перекусов.'
    },
    {
      icon: Scale,
      title: 'Контроль порций',
      description: 'Следите за размером порций. Используйте маленькие тарелки и уделяйте внимание чувству насыщения.'
    },
    {
      icon: Heart,
      title: 'Здоровый сон',
      description: 'Недостаток сна связан с повышением ИМТ. Старайтесь спать 7-8 часов каждую ночь.'
    },
    {
      icon: BarChart,
      title: 'Регулярный мониторинг',
      description: 'Отслеживайте свой вес и ИМТ раз в 1-2 недели для контроля динамики.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы для здорового ИМТ
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Индивидуальные особенности
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              ИМТ не учитывает индивидуальные особенности телосложения, мышечную массу и распределение жира. 
              Для полноценной оценки здоровья обратитесь к терапевту или эндокринологу.
            </p>
            <a 
              href="https://www.minzdrav.gov.ru/news/2021/10/15/17352-minzdrav-rossii-predstavil-novyy-informatsionnyy-resurs-dlya-patsientov"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-block py-1.5 text-center text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
            >
              Рекомендации Минздрава РФ
            </a>
          </div>
        </div>
      </div>

      {/* Российские рекомендации */}
      <div className="mt-4 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <h4 className="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-2">Национальный проект "Демография"</h4>
        <p className="text-xs text-emerald-600 dark:text-emerald-400">
          В рамках федерального проекта "Укрепление общественного здоровья" реализуются меры по формированию 
          системы мотивации граждан к здоровому образу жизни и правильному питанию. Подробную информацию, 
          рекомендации и калькуляторы можно найти на сайте проекта "Здоровое питание".
        </p>
      </div>
    </div>
  );
};

export default TipsSidebar;